import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";
import {
  useVbsConfirmationPatchMutation,
  useVbsConfirmationShowQuery,
} from "@/services/backend/vbs/confirmations/api/confirmation-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { ServiceContactCardWithMutation } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function AddressesAndContactsRoute() {
  const { confirmationId } = useParams();
  const {
    data: confirmation,
    isLoading,
    error,
  } = useVbsConfirmationShowQuery({
    id: confirmationId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <PostalAddressCardWithMutation
        id={confirmation!.id}
        address={confirmation!.postalAddress}
        mutation={useVbsConfirmationPatchMutation}
        disabled={isImmutable(confirmation!)}
      />
      <ServiceAddressCardWithMutation
        id={confirmation!.id}
        address={confirmation!.serviceAddress}
        mutation={useVbsConfirmationPatchMutation}
        disabled={isImmutable(confirmation!)}
      />
      <ServiceContactCardWithMutation
        id={confirmation!.id}
        serviceContact={confirmation!.serviceContact}
        mutation={useVbsConfirmationPatchMutation}
        disabled={isImmutable(confirmation!)}
      />
      <RepresentativeCardWithMutation
        id={confirmation!.id}
        representative={confirmation!.representative}
        mutation={useVbsConfirmationPatchMutation}
        disabled={isImmutable(confirmation!)}
      />
    </div>
  );
}
